/*

Use rollbar and make redundant

*/
export default function send_error(error_out){
  console.error("Moonbase Error:",error_out); // yes a moonsift-firebase error is a moonbase error.... :S
}
